import React, { useState } from 'react';
import classNames from 'classnames';
import { getVipTag, getIncomeSource, getVipDesc, isAppStorePay, isWeb } from '@/utils/vip';
import { CutoutNumberType } from '@/services/user/index.d';
import AvatarDefault from '@/assets/image/vip/avatar-default.png';
import Svip from '@/assets/image/vip/svip.png';
import VipWeb from '@/assets/image/vip/vip-web.png';
import Vip from '@/assets/image/vip/vip.png';
import NoVip from '@/assets/image/vip/no-vip.png';
import NoVipWeb from '@/assets/image/vip/no-vip-web.png';
import ProVip from '@/assets/image/vip/pro-vip.png';
import TeamVip from '@/assets/image/team/team-vip.png';
import TeamNoVip from '@/assets/image/team/team-no-vip.png';
import LoginMethods from '../login-methods';
import { getSkuType, getUrlParam } from '@/utils';
import { SubscribeType, isTeamSubscription, subscribeType } from '@/constants';
import dayjs from 'dayjs';
import Modal from '../modal';

import styles from './index.module.css';
import { TabType } from '@/constants/subscription';
import { useAtom } from 'jotai';
import {
  batchSizeAtom,
  curTabAtom,
  cutoutInfoAtom,
  hasFetchUserInfoAtom,
  meidouTotalAtom,
  teamInfoAtom,
  userInfoAtom,
  vipInfoAtom,
  visibleMeidouInfoModalAtom,
} from '@/store';
import { track } from '@/utils/common';

interface IProps {
  handleLogin?: () => void;
}

const Userinfo: React.FC<IProps> = ({ handleLogin }) => {
  const type = getUrlParam('type'); // PC端订阅URL里定义的参数，区分是会员还是批处理
  const hideSwitchBtn = !!+(getUrlParam('hideSwitchBtn') || '0'); // 单购场景下，是否暴露会员和张数的切换入口

  const [visible, setVisible] = useState<boolean>(false);

  const [curTab, setCurTab] = useAtom(curTabAtom);
  const [hasFetchUserInfo] = useAtom(hasFetchUserInfoAtom);
  const [userInfo] = useAtom(userInfoAtom);
  const [teamInfo] = useAtom(teamInfoAtom);
  const [batchSize] = useAtom(batchSizeAtom);
  const [cutoutInfo] = useAtom(cutoutInfoAtom);
  const [vipInfo] = useAtom(vipInfoAtom);
  const [meidouTotal] = useAtom(meidouTotalAtom);
  const [, setVisibleMeidouInfoModal] = useAtom(visibleMeidouInfoModalAtom);

  const handleJumpAccount = () => {
    let prefix = process.env.REACT_APP_ENV;

    if (process.env.REACT_APP_ENV === 'release') {
      prefix = '';
    }

    const url = `https://${prefix}account.meitu.com/#!/account`;

    if (getIncomeSource() === 'MTXX-WEB') {
      window.open(url);
    } else {
      // native.openBrowser(url);
    }
  };

  const handleViewDetail = () => {
    setVisible(true);

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'look_detail',
      },
    });
  };

  const handleTabChange = () => {
    const value = curTab === TabType.CUTOUT ? TabType.SUB : TabType.CUTOUT;
    setCurTab(value);

    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: value === TabType.CUTOUT ? 'buynum' : 'buyvip',
        sku_type: getSkuType(),
      },
    });
  };

  const handleMeidouInfoClick = () => {
    setVisibleMeidouInfoModal(true);
    track({
      event_id: 'vip_page_click',
      event_name: '会员落地页点击',
      params: {
        class: 'surplus',
      },
    });
  };

  const renderSwitchTab = () => {
    if (hideSwitchBtn) return;

    return (
      <div className={styles.viewDetail} onClick={handleTabChange}>
        {curTab === TabType.CUTOUT
          ? isTeamSubscription
            ? '开通会员不限量'
            : '购买会员'
          : '购买张数'}
      </div>
    );
  };

  const renderDesc = () => {
    if (type === 'svip') {
      // batchSize
      return `批处理剩余张数：${batchSize}`;
    }
    if (subscribeType === SubscribeType.CONSUMABLE) {
      // 抠图剩余张数
      const leftNumber = cutoutInfo?.left || 0;
      return (
        <>
          <div style={{ cursor: 'initial' }}>
            剩余抠图张数：
            <span
              className={styles.number}
              onClick={() => leftNumber && handleViewDetail()}
              style={{
                textDecoration: leftNumber && 'underline',
              }}
            >
              {leftNumber}
            </span>
          </div>

          {renderSwitchTab()}

          <Modal
            visible={visible}
            wrapStyle={{
              borderRadius: getIncomeSource() !== 'MTXX-WEB' ? 0 : '0 12px 12px 0',
              cursor: 'default',
              backgroundColor: 'rgba(0, 0, 0, 0.2)',
            }}
            style={{ width: 400, height: 'auto' }}
            onClose={() => setVisible(false)}
          >
            <div className={styles.modalTitle}>剩余下载张数</div>
            <div className={styles.modalSubTitle}>优先消耗临期张数</div>
            <div className={styles.modalList}>
              {/* 过滤已过期的 */}
              {cutoutInfo?.details
                ?.filter(
                  (item) => !(item.type === CutoutNumberType.TIMELIMIT && item.days_left < 1)
                )
                ?.sort((a, b) => {
                  if (b.type === a.type) {
                    return a.days_left - b.days_left;
                  } else {
                    return b.type - a.type;
                  }
                })
                ?.map((item, index) => (
                  <div className={styles.modalRow} key={index}>
                    <div className={styles.modalRowLabel}>
                      {item.type === CutoutNumberType.PERMANENT
                        ? '永久有效'
                        : `${item.days_left}天后过期`}
                    </div>
                    <div className={styles.modalRowValue}>
                      {item.num_left} <span className={styles.unit}>张</span>
                    </div>
                  </div>
                ))}
            </div>
            <div className={styles.modalTips}>
              <div>消耗张数时机：</div>
              <div>1、你在抠图编辑器内下载抠完的图片时，我们将根据下载图片张数进行计算扣除。</div>
              <div>2、未重新处理过的图片、未产生抠图的图片进行反复下载，将不会扣除张数。</div>
            </div>
            <div className={styles.modalBtn} onClick={() => setVisible(false)}>
              好的
            </div>
          </Modal>
        </>
      );
    }

    if (
      (subscribeType === SubscribeType.MEIDOU && curTab === TabType.MEIDOU) ||
      subscribeType === SubscribeType.MEIDOUPACKAGE
    ) {
      return (
        <div onClick={handleMeidouInfoClick}>
          <>
            {subscribeType === SubscribeType.MEIDOUPACKAGE && vipInfo?.is_vip
              ? `您的商拍套餐将于${dayjs((vipInfo.vip_end_time || 0) * 1000).format(
                  'YYYY/MM/DD'
                )}到期，`
              : ''}
          </>
          美豆剩余{meidouTotal}
          {isTeamSubscription && vipInfo?.is_vip ? (
            <>
              <span className={styles.divider}></span>
              <span>
                团队版会员将于
                {dayjs((vipInfo.vip_end_time || 0) * 1000).format('YYYY/MM/DD HH:mm')}到期
              </span>
            </>
          ) : null}
        </div>
      );
    }

    return (
      <>
        <div onClick={handleJumpAccount}>{getVipDesc(vipInfo)}</div>
        {/* <span className={styles.separater}></span>
        <div className={styles.switchBtn} onClick={onSwitchAccount}>
          切换账号
        </div> */}
      </>
    );
  };

  const renderMethods = () => {
    if (isTeamSubscription) {
      const phone = teamInfo?.super_admin?.phone;
      return phone ? <span className={styles.loginMethods}>（已绑定账号： {phone}）</span> : null;
    }

    if (userInfo?.login_methods?.length) {
      return (
        <span className={styles.loginMethods}>
          （已绑定账号：
          <LoginMethods userInfo={userInfo} />）
        </span>
      );
    }
  };

  const showVipTag =
    hasFetchUserInfo &&
    userInfo?.id &&
    !getVipTag(vipInfo).hasNoBuy &&
    subscribeType !== SubscribeType.MEIDOUPACKAGE && // 非美豆套餐订阅
    type !== 'svip'; // 非批处理

  const vipIcon = isTeamSubscription ? TeamVip : isWeb ? VipWeb : Svip;
  const noVipIcon = isTeamSubscription ? TeamNoVip : isWeb ? NoVipWeb : NoVip;
  const avatar = isTeamSubscription ? teamInfo?.logo : userInfo?.avatar;
  const name = isTeamSubscription ? teamInfo?.name : userInfo?.screen_name;

  return (
    <div className={classNames(styles.module, isTeamSubscription && styles.teamSubscription)}>
      <div className={styles.avatarBox}>
        {avatar ? (
          <img
            className={classNames(
              styles.avatar,
              getVipTag(vipInfo).svip && styles.avatarSvip,
              getVipTag(vipInfo).vip && styles.avatarVip
            )}
            src={avatar || AvatarDefault}
            alt=""
            onClick={handleJumpAccount}
          />
        ) : (
          <div
            className={classNames(styles.defaultAvatar, !hasFetchUserInfo && styles.skeleton)}
            style={{ cursor: 'pointer' }}
            onClick={handleLogin}
          ></div>
        )}
        {showVipTag ? (
          <img
            className={styles.vipIcon}
            src={
              getVipTag(vipInfo).proVip
                ? ProVip
                : getVipTag(vipInfo).svip
                ? vipIcon
                : getVipTag(vipInfo).vip
                ? Vip
                : noVipIcon
            }
            alt=""
          />
        ) : null}
      </div>
      <div className={styles.right}>
        {userInfo?.id ? (
          <div className={styles.username} onClick={handleJumpAccount}>
            {name}
            {renderMethods()}
          </div>
        ) : (
          <div
            className={classNames(styles.username, !hasFetchUserInfo && styles.skeleton)}
            onClick={handleLogin}
          >
            {isAppStorePay() ? '点击登录' : '点击登录（登录即注册）'}
          </div>
        )}

        <div className={styles.bottom}>
          {userInfo?.id ? (
            renderDesc()
          ) : (
            <div className={!hasFetchUserInfo ? styles.skeleton : ''} onClick={handleLogin}>
              {isAppStorePay()
                ? '请登录后购买会员，以确保您的会员作品不会丢失'
                : `请登录后购买${type === 'svip' ? '' : '会员'}`}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Userinfo;
